import { onCleanup } from "solid-js";
import { setSettings, settings } from "../stores/settings.ts";

/**
 * Global hotkeys. Phase 4 expands this with command palette and
 * per-panel focus shortcuts.
 *
 * - p → toggle presentation mode
 * - s → toggle sound
 * - n → toggle desktop notifications
 * - ? → cheat sheet (Phase 4)
 */
export function registerHotkeys() {
  const handler = (e: KeyboardEvent) => {
    if (e.target instanceof HTMLInputElement) return;
    if (e.target instanceof HTMLTextAreaElement) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;

    switch (e.key) {
      case "p":
        setSettings("presentationMode", (v) => !v);
        break;
      case "s":
        setSettings("soundEnabled", (v) => !v);
        break;
      case "n":
        setSettings("notificationsEnabled", (v) => !v);
        if (settings.notificationsEnabled && "Notification" in window) {
          void Notification.requestPermission();
        }
        break;
    }
  };

  window.addEventListener("keydown", handler);
  onCleanup(() => window.removeEventListener("keydown", handler));
}
